export default function ComparisonTable() {
  const rows = [
    { feature: "Speed", itaobuy: "Fast", manual: "Slow", agents: "Medium", itaobuyIcon: "ri-flashlight-line", itaobuyClass: "text-accent-600" },
    { feature: "Cost", itaobuy: "Low", manual: "High", agents: "High", itaobuyIcon: "ri-money-dollar-circle-line", itaobuyClass: "text-accent-600" },
    { feature: "Transparency", itaobuy: "High", manual: "Low", agents: "Medium", itaobuyIcon: "ri-eye-line", itaobuyClass: "text-accent-600" },
    { feature: "Scalability", itaobuy: "High", manual: "Low", agents: "Medium", itaobuyIcon: "ri-bar-chart-line", itaobuyClass: "text-accent-600" },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-[0.15em] uppercase mb-3 whitespace-nowrap">
            Why It Stands Out
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Why ItaobuySpreadsheet
            <br />
            Outperforms Traditional Sourcing
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Feature</th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-primary-500 whitespace-nowrap">
                  ItaobuySpreadsheet
                </th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Manual Sourcing</th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-500 whitespace-nowrap">Agents</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.feature} className="border-b border-background-200/60 hover:bg-background-50/80 transition-colors">
                  <td className="py-4 px-4 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className="py-4 px-4 text-center">
                    <span className={`inline-flex items-center gap-1.5 text-sm font-semibold ${row.itaobuyClass} whitespace-nowrap`}>
                      <i className={row.itaobuyIcon}></i>
                      {row.itaobuy}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center text-sm text-foreground-500 whitespace-nowrap">{row.manual}</td>
                  <td className="py-4 px-4 text-center text-sm text-foreground-500 whitespace-nowrap">{row.agents}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}